var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"#0B3F67","dark":""},on:{"click":function($event){return _vm.descargarDocumento()}}},on),[_vm._v("Descargar Manual"),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-download")])],1)]}}])},[_vm._v(" Descagar ")])}
var staticRenderFns = []

export { render, staticRenderFns }